import React from 'react'
import { Helmet } from 'react-helmet-async'
import ReviewsContent from '../components/reviews/ReviewsContent'

export default function Reviews() {
  return (
    <>
      <Helmet>
        <title>Reviews - A Plus A Driving School</title>
        <meta name="description" content="Read reviews from our satisfied students and parents. See why A Plus A Driving School is Virginia's premier driving school." />
      </Helmet>
      <ReviewsContent />
    </>
  )
}

